module.exports = __webpack_public_path__ + "static/img/首页banner.82e825b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/首页banner.png
// module id = VDbG
// module chunks = 192